import { useState, useEffect } from 'react'

export enum DeviceType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

/**
 * Follow the viewport width and return device type (mobile or desktop)
 * @param width - widest viewport that counts as mobile, default is 970px
 */
export const useDeviceType = (width = 970) => {
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Desktop)

  useEffect(() => {
    // A media query is matched against the screen width. window.innerWidth is not: on a phone it
    // grows with content that overflows the screen, so a wide page would keep reporting desktop.
    // The query is the one BaseLayout switches headers on, so a printout gets desktop from both.
    const mobileQuery = window.matchMedia(`screen and (max-width: ${width}px)`)

    const update = () => {
      setDeviceType(mobileQuery.matches ? DeviceType.Mobile : DeviceType.Desktop)
    }

    update()

    mobileQuery.addEventListener('change', update)

    return () => {
      mobileQuery.removeEventListener('change', update)
    }
  }, [width])

  return deviceType
}